import { Alert, Snackbar } from "@mui/material";

export type SnackMessageProps = {
    open: boolean
    text: string
    color?: "error" | "info" | "success" | "warning"
}

type SnackBarProps = {
    value: SnackMessageProps
    setValue: React.Dispatch<React.SetStateAction<SnackMessageProps>>
}

export default function SnackBar({ value, setValue }: SnackBarProps) {
    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            open={value.open}
            onClose={() => setValue({ ...value, open: false })}
            autoHideDuration={5000}
            sx={{ zIndex: 9999 }}
        >
            <Alert
                onClose={() => setValue({ ...value, open: false })}
                severity={value.color ? value.color : "info"}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {value.text}
            </Alert>
        </Snackbar>
    );
}